import styles from './StudentSection.module.css';

import IconAndName from '../../components/IconAndName/IconAndName';

import { FaUserPlus, FaUpload } from 'react-icons/fa';
import { useState } from 'react';

import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';

import CopyRight from '../../components/CopyRight/CopyRight';
import StudentsList from '../../sections/StudentsListTable/StudentsList';
import { FiDownload } from 'react-icons/fi';
import ThreeDotMenu from '../../components/ThreeDotMenu/ThreeDotMenu';
import { useNavigate } from 'react-router';

const StudentSection = () => {
  // default or make it dynamic later
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAddStudent = () => {
    dispatch(openModal('addStudent'));
  };

  const handleBulkUpload = () => {
    dispatch(openModal('bulkUploadStudent'));
  };

  const downloadOptions = [
    {
      label: 'Student List',
      onClick: () => {
        navigate('/management/students/download/reports');
      },
    },
    { label: 'Student Allergy Data', onClick: () => {} },
    {
      label: 'Student QR Code',
      onClick: () => {
        dispatch(
          openModal({
            type: 'selectStudents',
            data: {
              nextModal: 'QRCodeList',
            },
          })
        );
      },
    },
  ];

  return (
    <>
      <div className={styles.StudentSection}>
        <div className={styles.maincontainer}>
          <div className={styles.buttonRow}>
            <IconAndName
              icon={<FaUserPlus />}
              title="Add Student"
              bgColor="Primary_Color"
              onClick={handleAddStudent}
            />
            <IconAndName
              icon={<FaUpload />}
              title="Bulk Upload"
              bgColor="Primary_Color"
              onClick={handleBulkUpload}
            />
            <ThreeDotMenu
              icon={<FiDownload size={28} color="var(--Primary_Color)" />}
              options={downloadOptions}
            />
          </div>
        </div>
        <StudentsList />
      </div>

      <CopyRight />
    </>
  );
};

export default StudentSection;
